import {combine, merge, sample} from 'effector';
import i18next from 'i18next';
import {toast} from 'react-toastify';

import {RestError, showRestError} from 'core/errors';

import {
    boundUserWithParticipantFx,
    createUserFx,
    data$,
    editUserData$,
    fetchDataFx,
    Gate,
    idsForRemoveBoundedConfirmation$,
    onChangeIdsForBoundConfirmation,
    onChangeUserIdForRemoveConfirmation,
    onSetEditUser,
    pageNumber$,
    pageNumberChanged,
    pageSize$,
    pageSizeChanged,
    removeUserFx,
    updateUserFx,
    userIdForRemoveConfirmation$,
} from './index';

data$.on(fetchDataFx.doneData, (_, data) => data).reset(Gate.close);
userIdForRemoveConfirmation$
    .on(onChangeUserIdForRemoveConfirmation, (_, payload) => payload)
    .reset(Gate.close);
idsForRemoveBoundedConfirmation$
    .on(onChangeIdsForBoundConfirmation, (_, payload) => payload)
    .reset(Gate.close);
editUserData$.on(onSetEditUser, (_, payload) => payload);
pageNumber$.reset(Gate.close);
pageSize$.reset(Gate.close);

sample({
    clock: merge([Gate.open, pageNumberChanged, pageSizeChanged, removeUserFx.done]),
    source: combine({
        pageNumber: pageNumber$,
        pageSize: pageSize$,
    }),
    fn: ({pageNumber, pageSize}) => ({
        pageNumber,
        pageSize,
    }),
    target: fetchDataFx,
});

createUserFx.doneData.watch(() => toast.success(i18next.t('pages.register.message.success')));
updateUserFx.doneData.watch(() => toast.success(i18next.t('pages.register.message.update')));
removeUserFx.doneData.watch(() => toast.success(i18next.t('pages.register.message.remove')));
boundUserWithParticipantFx.doneData.watch(() =>
    toast.success(i18next.t('pages.register.message.update')),
);

[fetchDataFx, createUserFx, updateUserFx, removeUserFx, boundUserWithParticipantFx].forEach((fx) =>
    fx.failData.watch((err) => showRestError(err as RestError)),
);
